import { render, staticRenderFns } from "./form-create.vue?vue&type=template&id=94fe0c1a&scoped=true&"
import script from "./form-create.vue?vue&type=script&lang=js&"
export * from "./form-create.vue?vue&type=script&lang=js&"
import style0 from "./form-create.vue?vue&type=style&index=0&id=94fe0c1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fe0c1a",
  null
  
)

export default component.exports